/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.171.0-v202607242315-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqDisplayTemplatesApiClass {
 
   constructor() {}

  /**
   * @summary Archive a display template
   * @param {string} id - ID of the display template to archive.
  */
  public archiveDisplayTemplate(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/display-templates/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Create a new template item for a display
  */
  public createDisplayTemplate(
    body: models.DisplayTemplateInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/display-templates`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.DisplayTemplateOutputV1>;
  }

  /**
   * @summary Get a display template item
   * @param {string} id - The Seeq ID for the display template
  */
  public getDisplayTemplate(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/display-templates/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.DisplayTemplateOutputV1>;
  }

  /**
   * @summary Get a list of display template items
   * @param {number} [offset=0] - The pagination offset, the index of the first display template item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of display template items that will be returned in this page of results
  */
  public getDisplayTemplates(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/display-templates`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.DisplayTemplateOutputListV1>;
  }

  /**
   * @summary Update a template item for a display
   * @param {string} id - The Seeq ID for the display template
  */
  public updateTemplate(
    body: models.DisplayTemplateInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/display-templates/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.DisplayTemplateOutputV1>;
  }

}


export const sqDisplayTemplatesApi = new sqDisplayTemplatesApiClass();

export type sqDisplayTemplatesApiEndpoints = {
  'archiveDisplayTemplate': {
    method: 'delete';
    path: '/display-templates/${encodeURIComponent(String(id))}';
    response: models.ArchiveOutputV1;
  };
  'createDisplayTemplate': {
    method: 'post';
    path: '/display-templates';
    response: models.DisplayTemplateOutputV1;
  };
  'getDisplayTemplate': {
    method: 'get';
    path: '/display-templates/${encodeURIComponent(String(id))}';
    response: models.DisplayTemplateOutputV1;
  };
  'getDisplayTemplates': {
    method: 'get';
    path: '/display-templates';
    response: models.DisplayTemplateOutputListV1;
  };
  'updateTemplate': {
    method: 'post';
    path: '/display-templates/${encodeURIComponent(String(id))}';
    response: models.DisplayTemplateOutputV1;
  };
};

type ApiArchiveDisplayTemplateResponse = models.ArchiveOutputV1;
type ApiarchiveDisplayTemplateMutationParams = Parameters<typeof sqDisplayTemplatesApi.archiveDisplayTemplate> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDisplayTemplatesApi.archiveDisplayTemplate>;

export function useApiArchiveDisplayTemplateMutation(
  options?: Omit<UseMutationOptions<ApiArchiveDisplayTemplateResponse, AxiosError<SeeqErrorData>,
    ApiarchiveDisplayTemplateMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiArchiveDisplayTemplateResponse, AxiosError<SeeqErrorData>,
  ApiarchiveDisplayTemplateMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiarchiveDisplayTemplateMutationParams) =>
      sqDisplayTemplatesApi.archiveDisplayTemplate(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateDisplayTemplateResponse = models.DisplayTemplateOutputV1;
type ApicreateDisplayTemplateMutationParams = Parameters<typeof sqDisplayTemplatesApi.createDisplayTemplate> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDisplayTemplatesApi.createDisplayTemplate>;
type ApicreateDisplayTemplateMutationVariables = models.DisplayTemplateInputV1;

export function useApiCreateDisplayTemplateMutation(
  options?: Omit<UseMutationOptions<ApiCreateDisplayTemplateResponse, AxiosError<SeeqErrorData>,
    ApicreateDisplayTemplateMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateDisplayTemplateResponse, AxiosError<SeeqErrorData>,
  ApicreateDisplayTemplateMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateDisplayTemplateMutationVariables) =>
      sqDisplayTemplatesApi.createDisplayTemplate(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetDisplayTemplateResponse = models.DisplayTemplateOutputV1;
export function GetDisplayTemplateQueryKey(
  params: Parameters<typeof sqDisplayTemplatesApi.getDisplayTemplate>[0],
) {
  return ['sqDisplayTemplatesApi', 'getDisplayTemplate', params] as const;
}

export function useApiGetDisplayTemplateQuery(
  params: Parameters<typeof sqDisplayTemplatesApi.getDisplayTemplate>[0],
  options?: Omit<UseQueryOptions<ApiGetDisplayTemplateResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetDisplayTemplateResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetDisplayTemplateQueryKey(params),
    queryFn: () =>
      sqDisplayTemplatesApi.getDisplayTemplate(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetDisplayTemplatesResponse = models.DisplayTemplateOutputListV1;
export function GetDisplayTemplatesQueryKey(
  params: Parameters<typeof sqDisplayTemplatesApi.getDisplayTemplates>[0],
) {
  return ['sqDisplayTemplatesApi', 'getDisplayTemplates', params] as const;
}

export function useApiGetDisplayTemplatesQuery(
  params: Parameters<typeof sqDisplayTemplatesApi.getDisplayTemplates>[0],
  options?: Omit<UseQueryOptions<ApiGetDisplayTemplatesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetDisplayTemplatesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetDisplayTemplatesQueryKey(params),
    queryFn: () =>
      sqDisplayTemplatesApi.getDisplayTemplates(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiUpdateTemplateResponse = models.DisplayTemplateOutputV1;
type ApiupdateTemplateMutationParams = Parameters<typeof sqDisplayTemplatesApi.updateTemplate> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqDisplayTemplatesApi.updateTemplate>;

export function useApiUpdateTemplateMutation(
  options?: Omit<UseMutationOptions<ApiUpdateTemplateResponse, AxiosError<SeeqErrorData>,
    ApiupdateTemplateMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateTemplateResponse, AxiosError<SeeqErrorData>,
  ApiupdateTemplateMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateTemplateMutationParams) =>
      sqDisplayTemplatesApi.updateTemplate(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
